import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApi } from '../../../network/itemList';
import {
  getSearchApiIsGroup,
  getSearchApiTypeIsGroup,
  getSearchPatients,
} from '../../../network/appointment';

const DeductionsListPayment = ({
  setDataSourcePayment,
  dataSourcePayment,
  t,
}) => {
  const [count, setCount] = useState(0);
  const [accountSearchTxt, setAccountSearchTxt] = useState('');
  const [costCenterSearchTxt, setCostCenterSearchTxt] = useState('');
  // const { data: costCenters } = useQuery({
  //   queryKey: [queryKeys.getCostCenterSearch],
  //   queryFn: () => getSearchApi('Cost Center'),
  //   keepPreviousData: true,
  // });
  // const { data: account } = useQuery({
  //   queryKey: [queryKeys.getSearchApiAccount],
  //   queryFn: () => getSearchApi('Account'),
  //   keepPreviousData: true,
  // });
  const { data: accountSearch, isLoading: isLoadingAccount } = useQuery({
    queryKey: [queryKeys.getSearchAccount, accountSearchTxt],
    queryFn: () =>
      getSearchApiTypeIsGroup({ type: 'Account', text: accountSearchTxt }),
    enabled: accountSearchTxt?.length >= 3 || accountSearchTxt?.length === 0,
  });
  const { data: costCenterSearch, isLoading: isLoadingCostCenter } = useQuery({
    queryKey: [queryKeys.getSearchCostCenter, costCenterSearchTxt],
    queryFn: () =>
      getSearchApiTypeIsGroup({
        type: 'Cost Center',
        text: costCenterSearchTxt,
      }),
    enabled:
      costCenterSearchTxt?.length >= 3 || costCenterSearchTxt?.length === 0,
  });
  const columns = [
    {
      title: t.Account,
      dataIndex: 'account',
      render: (text, record, index) => (
        <Select
          placeholder={t.Account}
          value={record?.account}
          style={{ width: '100%' }}
          showSearch
          popupMatchSelectWidth={false}
          onSearch={(value) => {
            setAccountSearchTxt(value);
          }}
          filterOption={false}
          options={accountSearch?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          loading={isLoadingAccount}
          onChange={(value, option) => {
            console.log(option, 'option');
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              account: value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.costCenter,
      dataIndex: 'cost_center',
      render: (text, record, index) => (
        <Select
          placeholder={t.costCenter}
          value={record?.cost_center}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          showSearch
          onSearch={(value) => {
            setCostCenterSearchTxt(value);
          }}
          filterOption={false}
          options={costCenterSearch?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          loading={isLoadingCostCenter}
          onChange={(value, option) => {
            console.log(option, 'option');
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              cost_center: value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          type="number"
          value={record.amount}
          style={{ width: '100%' }}
          onChange={(e) => {
            const newDataSource = [...dataSourcePayment];
            newDataSource[index] = {
              ...newDataSource[index],
              amount: e.target.value,
            };
            setDataSourcePayment(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      amount: 0,
    };
    setDataSourcePayment([...dataSourcePayment, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourcePayment.filter((item) => item.key !== key);
    setDataSourcePayment(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourcePayment}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        scroll={{ x: 'max-content' }}
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default DeductionsListPayment;
